export default __webpack_public_path__ + "static/media/ai-dev-graduate-background.cb0876eb.png";